import React from "react";
import Header from "../Global/Header";
import WebsiteBreadCrumbs from "../Global/WebsiteBreadCrumbs";
import DetailFirstSec from "./DetailFirstSec";
import Exploreall from "../Explore/Exploreall";
import Footer from "../Global/Footer";
import CompanyLogo from "../Global/CompanyLogo";
import { useEffect } from "react";

function DetailMainComponent() {
  useEffect(() => {
    document.title = "Floral Maxi Dress | Crowd Approved Fashion";
  }, []);

  return (
    <div className="background-image body-color ">
      <Header />
      <WebsiteBreadCrumbs />
      <DetailFirstSec />
      <Exploreall />
      <Footer />
      <CompanyLogo />
    </div>
  );
}

export default DetailMainComponent;
